<template>    
    <BaseModal
        :id="'static'"
        :title="title"
        :size="'lg'"
        message="Enter the First and Last name. Select a Role for access level. Enter an email address and phone. Click Save."
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="form_submit()">
                <FormDynamic
                    :form_format="form_format"
                    :form_data="form_data"
                    :array_options="array_options"
                    :for_update="false"
                />

                <!-- <div :class="'col-md-12'" class="p-0 formdynamic__item">
                    <div class="formdynamic__item__field">
                        <label v-html="`Reports to: ${should_report ? `<b style='color:red;'>*</b>` : ''}`" class="modal-label"/>
                        <select
                            :disabled="!should_report"
                            class="input-field custom-select"
                            :required="false"
                            v-model="form_data.report_associate_id"
                        >
                            <option value='' v-html="'Select an option'"/>
                            <option v-for="(value, i) in associates_roles" :key="i" :value="value.id" v-html="value.name"/>
                        </select>
                    </div>
                </div>

                <FormDynamic
                    :form_format="form_format2"
                    :form_data="form_data"
                    :array_options="array_options"
                    :for_update="false"
                /> -->
                <CentralButtons />
            </form>
        </template>
    </BaseModal>
</template>

<script>

import FormResources    from    './form_resources'
import FormDynamic      from    '@/components/FormDynamic.vue'
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal        from    '@/components/BaseModal'
import CentralButtons   from    '@/components/CentralButtons'

export default {

    name:   'FormModal',
    props: [
        'title',
        'rest_api',
        'notyf',
        'axios',
        'array_options',
        'breadcrumb',
        'associates_selected'
    ],

    components:{
        FormDynamic,
        Breadcrumb,
        BaseModal,
        CentralButtons,
    },

    data(){
        return{
            form_data:      FormResources.form_data,
            form_backup:    {...FormResources.form_data},
            form_format:    FormResources.form_main_format,
            // form_format2:   FormResources.form_format_lite2,
            associates_roles: [],
            should_report: true
        }
    },

    methods:{

        changeValidationReportsTo(param)
        {
            this.form_format[10].disabled = !param
            this.form_format[10].required = param

            this.form_format[10].disabled = param
            this.form_format[10].required = !param
        },

        refresh()
        {
            this.displayReportsTo(this.form_data.role_id)
        },

        async displayReportsTo(val)
        {
            if(val)
            {
                this.loader(true)
                
                const response = await this.post('reports_to_by_roles', {rol: val, id: this.form_data.id})

                if(response.status)
                {
                    this.array_options.report_associate_id = response.data.associates

                    if(response.data.should_report)
                    {
                        this.changeValidationReportsTo(false)

                        let found_associate =  this.array_options['report_associate_id'].findIndex(item => item.id === this.form_data.report_associate_id)

                        if(found_associate < 0)
                        {
                            this.form_data.report_associate_id = ''
                        }
                    }
                    else
                    {
                        this.changeValidationReportsTo(true)
                        this.form_data.report_associate_id = ''
                    }
                }

                this.loader()
            }

        }

    },

    mounted(){
        this.changeValidationReportsTo(true)
    },

    watch: {
        "form_data.role_id"(val)
        {
            this.displayReportsTo(val)
        }
    }
    
}
</script>